import { creatorbase } from '@round/api';

// The posts table, its imperative ensure twin, and the campaign modals that read
// a campaign's posts all build their TanStack Query keys from these params.
// Sharing the builder keeps every reader on the same cache entry.
export const getProjectDetailsPostsParams = (campaignId: number | undefined): creatorbase.GetPostsParams<false> => ({
    campaign_id: campaignId?.toString(),
});
